import API from "./axios";

export class EnterpriseService {
    getActiveEnterprisesList(): Promise<any> {
        return API.post(`api/index.php`, { action: 'getActiveEnterprisesList', src: 'dashboard', retrievalmode: 'mysql' });
    }
}